"use client";

import { PersonFunction } from "@/app/api/auth/[...nextauth]/lib/authOptions";

import { useState } from "react";
import DefaultUser from "@/assets/user/default.svg";
import { UserModal } from "@/app/pwa/components/UserDisplay/UserModal";
import Image from "../Image";

export type SessionUser = {
  id: string;
  name: string;
  email: string;
  appId: string;
  image?: string;
  personFunctions: PersonFunction[];
};

interface UserModalDisplayProps {
  user: SessionUser;
}
export function UserModalDisplay({ user }: UserModalDisplayProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="nav-user"
      >
        {user.image ? (
          <Image className="nav-user__img" src={user.image} alt="" />
        ) : (
          <DefaultUser className="nav-user__img" />
        )}
        <span className="nav-user__title nav-user__title--name">{user.name}</span>
      </button>
      {isOpen && (
        <UserModal
          isOpen={isOpen}
          onRequestClose={() => setIsOpen(false)}
          user={user}
        />
      )}
    </>
  );
}
